export default __webpack_public_path__ + "static/media/img14.c4620a7a.jpg";